<template>
  <Card tag="form" class="residential-mutate-presentation" @submit.prevent="$emit('submit')">
    <template #default>
      <div class="residential-mutate-presentation__input">
        <CustomFields
          :value="value"
          @input="e => $emit('updateValue', e)"
          :schema="customFieldSchemas"
          :data="value"
          :validator="validator"
          :placement="['presentation', 'residential:presentation']"
          :disabledFields="disabledFields"
        >
          <!-- render slots -->
          <template v-for="item in fields.slots" v-slot:[item.slotKey]>
            <FieldRenderer
              :validator="validator"
              :item="item"
              :value="value"
              @input="e => $emit('updateValue', { ...e, slot: true })"
            />
          </template>
        </CustomFields>
      </div>
    </template>
  </Card>
</template>

<script>
import { i18n } from '@/i18n'

import Card from '@/components/Card'
import { mapState } from 'vuex'
import CustomFields from '@kvass/custom-fields'
import FieldRenderer from '@/components/Residential/StepsFields/FieldRenderer.vue'

const meta = {
  order: 2,
  id: 'presentation',
  label: i18n.tc('presentation'),
  icon: ['fal', 'image'],
}

export { meta }
export default {
  props: {
    value: Object,
    labels: Object,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    fields: { type: Object, default: () => ({}) },
    disabledFields: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapState('Residential', {
      item: state => state.item,
    }),
  },

  components: {
    Card,
    CustomFields,
    FieldRenderer,
  },
}
</script>

<style lang="scss">
.residential-mutate-presentation {
  $cols: 6;

  &__input {
    display: grid;
    grid-template-columns: repeat($cols, 1fr);
    grid-gap: $form-gap;
  }

  .custom-fields {
    grid-column-end: span $cols;
  }
}
</style>
